/**
 * ReportContextBanner — shows when chat is linked to a report
 */

import { motion } from 'framer-motion';
import {
  getLoopSourceLabel,
  type AeternaLoopContextValue,
} from '../../../components/aeterna-loop';
import styles from '../AiConsultantPage.module.css';

interface ReportContextBannerProps {
  context: AeternaLoopContextValue | null;
  onClose: () => void;
}

export function ReportContextBanner({ context, onClose }: ReportContextBannerProps) {
  const label = context ? getLoopSourceLabel(context.sourceType) : '体检报告';
  const title = context ? context.sourceTitle : '体检报告';

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      className={styles.reportContextBanner}
    >
      <div className={styles.reportContextCopy}>
        <span className={styles.reportContextText}>
          当前对话关联{label}：{title}
        </span>
        {context?.evidenceBoundary && (
          <span className={styles.reportContextBoundary}>
            {context.evidenceBoundary}
          </span>
        )}
      </div>
      <button className={styles.reportContextClose} onClick={onClose} type="button">
        ×
      </button>
    </motion.div>
  );
}
